import { string } from 'yup'
import { validatePhoneWithDDI } from '@bonitour/common-functions'

export const contactPhoneSchema = {
  title: string().required('Nome do contato é obrigatório'),
  number: string()
    .required('Número do contato é obrigatório')
    .test('validate-phone', 'O número de telefone deve ser válido', validatePhoneWithDDI)
}
